import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { useParams, Navigate } from 'react-router-dom'

import { H2, Card, Paragraph } from '@newComponents'
import { GuildDonationScreenContent } from './GuildDonationScreenContent'

import { GuildDonationScreenQuery } from './__generated__/GuildDonationScreenQuery.graphql'

export const GuildDonationScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<GuildDonationScreenQuery>(
    graphql`
      query GuildDonationScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            name
            slugId

            minimumDonationAmount
            donationCurrency

            ...GuildDonationScreenContent_guild
          }
        }
      }
    `,
    { id: params.actorId }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return <Navigate to='/' replace />
  }

  if (
    !data.nodeBySlugId.donationCurrency ||
    !data.nodeBySlugId.minimumDonationAmount
  ) {
    return <Navigate to={`/${data.nodeBySlugId.slugId}`} />
  }

  return (
    <Card gap='$4' main>
      <H2>Donate to {data.nodeBySlugId.name}</H2>

      <Paragraph>
        Set your donation amount below, then enter your payment information.
      </Paragraph>

      <GuildDonationScreenContent guild={data.nodeBySlugId} />
    </Card>
  )
}

export default GuildDonationScreen
